import { gql, useQuery } from '@apollo/client';

const CHECK_POLICY_ACCESS_QUERY = gql`
  query CheckGlobalPolicyAccess($policy: String!) {
    devhub {
      checkPolicyAccess(policy: $policy) {
        policy
        hasAccess
      }
    }
  }
`;

/**
 * Hook to check if the current user has access to a global (non-application-scoped) policy.
 * Uses the fusion PolicyManager instead of direct AD group membership checks.
 *
 * @param policy - The global policy name to check (e.g. 'AccessCGAHierarchyReportPolicy')
 * @returns Object with hasAccess boolean, loading state, and optional error
 */
export const useGlobalPolicyAccess = (
  policy: string,
): { hasAccess: boolean; loading: boolean; error?: Error } => {
  const { data, loading, error } = useQuery(CHECK_POLICY_ACCESS_QUERY, {
    variables: { policy },
    errorPolicy: 'none',
  });

  const hasAccess = data?.devhub?.checkPolicyAccess?.hasAccess ?? false;

  return { hasAccess, loading, error };
};
